// Add To Cart By Props
<template>
  <slot
    :loading="loading"
    :error="error"
    :submit="submit"
    :add-error-message="addErrorMessage"
    :store-locator-url="storeLocatorUrl"
  />
</template>

<script>
export default {
  name: "ProductSubmit",
};
</script>

<script setup>
import {computed, watch} from "vue";
import {useAPIWrapper} from "@/vue/composables/useAPIWrapper";
import {useStore} from "vuex";
import {optimisticFromProduct} from "@/utils/optimistic-line";
import {dispatchCartErrorToast} from "@/utils/cart-error-toast";

const props = defineProps({
  id: {
    type: Number,
    required: true,
  },
  quantity: {
    type: Number,
    default: 1,
    required: false,
  },
  sellingPlan: {
    type: [Number, undefined],
    required: false,
  },
});

const store = useStore();
const storeLocatorUrl = "/pages/store-locator";

const {
  error,
  execute: submit,
  isLoading: loading,
} = useAPIWrapper(async () => {
  if (!props.id || props.id === 0) {
    throw new Error("No Variant ID.");
  }
  const product = store.state.product.product;
  const variant = (product?.variants || []).find(v => v.id == props.id);

  await store.dispatch("cart/addItem", {
    id: props.id,
    quantity: props.quantity,
    sellingPlan: props.sellingPlan,
    // No plan passed to the preview on purpose: `sellingPlan` here is camelCase
    // and neither the cart nor Shopify reads it — Shopify's key is
    // `selling_plan` — so this add lands as one-time whatever the prop says.
    // Previewing the subscription price would show a figure the line is not
    // going to have. Renaming the prop is a separate fix; it changes what is
    // sent to Shopify.
    _optimistic: optimisticFromProduct(product, variant),
  });
});

const addErrorMessage = computed(() => {
  const e = error.value;
  if (!e) return "";
  return e.message || "Unable to add to cart.";
});

watch(error, value => {
  if (value) dispatchCartErrorToast(store, value);
});
</script>
